import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import App from './App';
import { queryClient } from '@/lib/query-client';
import { applyLanguage } from '@/i18n';
import { useAuthStore } from '@/stores/auth.store';
import './index.css';

// NFR-03 — open in the user's own language, Arabic when there is no session yet.
applyLanguage(useAuthStore.getState().user?.language ?? 'AR');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster
          position="bottom-center"
          dir="rtl"
          toastOptions={{
            className: 'text-xs font-sans',
            duration: 4000,
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
